import React, { useEffect, useState } from 'react';
import AddOfferModal from './components/addOffertModal'; // Zmień ścieżkę jeśli trzeba
import axios from 'axios';

export default function Adminoffert() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [offers, setOffers] = useState([]);

  const onClose = () => {
    setShowCreateModal(false);
    setSelectedOffer(null);
  };

  const loadData = async () => {
    try {
      const response = await axios.get('https://megamont.pl/api/offers');
      setOffers(response.data);
    } catch (error) {
      console.error('Błąd podczas ładowania ofert:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Czy na pewno chcesz usunąć tę ofertę?")) {
      try {
        await axios.delete(`https://megamont.pl/api/offers/${id}`);
        loadData();
      } catch (error) {
        console.error('Błąd podczas usuwania oferty:', error);
      }
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className='main RealizationsPanel'>
      <h2 className="fw-bold border-bottom pb-2 mb-3 gradient-text">Oferta</h2>
      <section className="mt-4">
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center p-0 mb-1">
              <h3>Sekcja ofert</h3>
              <button className="btn btn-custom" onClick={() => setShowCreateModal(true)}>
                Dodaj Nową Ofertę
              </button>
            </div>
          </div>
          <div className="col-12 p-0 m-0 shadow">
            <table className='Table'>
              <thead> 
                <tr>
                  <th>ID</th>
                  <th>Nazwa Oferty</th>
                  <th>Akcje</th>
                </tr>
              </thead>
              <tbody>
                {offers.length > 0 ? offers.map((offer) => (
                  <tr key={offer.id}>
                    <td>{offer.id}</td>
                    <td>{offer.name}</td>
                    <td>
                      <button 
                        className="btn btn-sm btn-primary me-2" 
                        onClick={() => { setSelectedOffer(offer); setShowCreateModal(true); }}
                      >
                        Edytuj
                      </button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(offer.id)}>
                        Usuń
                      </button>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="3" className="text-center">Brak danych.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      
      {showCreateModal && (
        <AddOfferModal 
          Offer={selectedOffer} 
          onClose={onClose} 
          refreshData={loadData} 
        />
      )}
    </div>
  );
}